var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcReviewBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#485057",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.55 3.387l.505-.534c.127-.127.191-.273.194-.436.002-.164-.06-.31-.187-.436l-.168-.176c-.113-.112-.25-.162-.41-.15-.162.012-.303.08-.425.201l-.52.513 1.01 1.018zm-8.27 7.456l1.392-.593 6.365-6.357-1.011-1.004L7.66 9.254l-.622 1.34c-.035.069-.02.136.044.202.063.066.129.081.197.047zm5.523 4.578c.644 0 1.146-.186 1.505-.557.359-.37.538-.92.538-1.648v-7.36l-1.26 1.252v6.006c0 .351-.081.614-.245.787-.164.173-.362.26-.597.26h-7.99c-.333 0-.587-.087-.762-.26-.176-.173-.264-.436-.264-.787V5.35c0-.347.088-.608.264-.784.175-.175.43-.263.761-.263h6.087l1.252-1.253h-7.39c-.737 0-1.294.185-1.67.553-.376.369-.564.92-.564 1.652v7.961c0 .728.188 1.277.564 1.648.376.371.933.557 1.67.557h8.1z",
    transform: "translate(-257 -1259) translate(0 1080) translate(16 19) translate(0 34) translate(0 10) translate(0 101) translate(223.636) translate(18 14) translate(0 1)"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReviewBlack);
export default __webpack_public_path__ + "static/media/ic_review_black.435e72693c7ef1c230fb3f5255aada05.svg";
export { ForwardRef as ReactComponent };